// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24355":"1f8c748c","52095":"9e3e85c9","76572":"d077974c","93398":"2d56a952"}[chunkId] + ".chunk.css";
};